import {Controller} from "stimulus";
import loader from "../../assets/loader";

export default class extends Controller {
  static targets = [
    "machineRow", "table"
  ];

  delete(event) {
    loader.show();
    let machine_id = event.target.dataset.machineId;
    fetch(`/offer/draft/delete/machine_id/${machine_id}/`, {
      method: 'POST'
    })
      .then(response => {
        if (response.status !== 200) return;

        this.machineRowTargets.some(row => {
          if (row.dataset.machineId == machine_id) {
            row.parentElement.removeChild(row);
            return true;
          }
        });
        if (this.machineRowTargets.length === 0) {
          this.tableTarget.parentElement.removeChild(this.tableTarget);
        }
      }).finally(
      () => loader.hide()
    );
  }

}
